import React from 'react';
import PropTypes from 'prop-types';

function DistributionCard({ distributionFile, uploadDistributionFile }) {
  const uploadFileLabel = distributionFile ? distributionFile.name : 'Choose File';
  return (
    <div className="card h-100 border-primary">
      <h4 className="p-3 bg-primary text-white">Distribution</h4>
      <div className="card-body">
        <h4>Distribution CSV File</h4>
        <div className="custom-file">
          <input
            type="file"
            className="custom-file-input"
            id="compareDistributionFile"
            onChange={uploadDistributionFile}
          />
          <label className="custom-file-label" htmlFor="compareDistributionFile">
            {uploadFileLabel}
          </label>
          <small className="form-text text-muted">
            The file must be a csv file and have an &quot;email&quot; (all lowercase) column.
          </small>
        </div>
      </div>
    </div>
  );
}

DistributionCard.propTypes = {
  distributionFile: PropTypes.instanceOf(File),
  uploadDistributionFile: PropTypes.func.isRequired,
};

DistributionCard.defaultProps = {
  distributionFile: null,
};

export default DistributionCard;
